import productlistModule from '../scripts/productList/productList.module.js';

import appDependency from '../scripts/appDependency.js';

appDependency.addItem(productlistModule);
